var m = require('mithril');
var prop = require('mithril/stream');
var buttonElement = require('./button');

var component = {};

/*

  Example of tabs

  tabs = {
    Status: status,
    Configuration: configuration,
    Alarms: alarms,
    Sampling: sampling,
    Overrides: overrides
  };

*/

component.oninit = function (vnode) {
  var ctrl = this;
  ctrl.tabs = vnode.attrs.tabs;
  ctrl.options = vnode.attrs.options || {};
  ctrl.onChange = vnode.attrs.onChange;
  ctrl.labelRenderer = vnode.attrs.labelRenderer;
  ctrl.route = vnode.attrs.route;
  ctrl.tab = prop(ctrl.route ? m.route.param(ctrl.route) || Object.keys(ctrl.tabs)[0] : Object.keys(ctrl.tabs)[0]);

  ctrl.selectTab = function (tabName) {
    if (ctrl.route) {
      ctrl.tab(tabName);
      var params = m.parseQueryString(m.route.get().split('?')[1]);
      params[ctrl.route] = tabName;
      m.route.set(m.route.get().split('?')[0], params, {replace: true});
    } else {
      ctrl.tab(tabName);
    }
    if (typeof ctrl.onChange === 'function') ctrl.onChange(tabName);
  }

  ctrl.activeTab = function () {
    var theTabString;
    if (ctrl.route) {
      return m.route.param(ctrl.route) || ctrl.tab();
    } else {
      return ctrl.tab();
    }
  }

  // var currentTabIsValid = Object.keys(ctrl.tabs).indexOf(ctrl.tab()) > -1;
  // if (currentTabIsValid) {
  //   ctrl.tab(ctrl.tab());
  // } else {
  //   ctrl.tab = prop(ctrl.options['default']);
  // }
};

component.view = function () {
  var ctrl = this
  var selectedTab = ctrl.activeTab();
  if (!ctrl.tabs[selectedTab]) {
    selectedTab = ctrl.tab();
  }
  
  function tabs () {
    var tabKeys = Object.keys(ctrl.tabs);
    var pills = [];

    for (var i = 0; i < tabKeys.length; i++) {
      var tab = tabKeys[i];
      var wrapperClass = ctrl.options.horizontal ? 'w-100 w-50-ns w-25-l' : 'w-100';
      var tabClass = 'w-100 mb2 truncate';
      var label = typeof ctrl.labelRenderer === 'function' ? ctrl.labelRenderer(tab) : tab;

      var hasRightSibling = ctrl.options.horizontal && (i % 2 === 0) && (i + 1 < tabKeys.length);
      if (hasRightSibling) wrapperClass += ' pr2-ns';

      var hasRightSiblingLarge = ctrl.options.horizontal && (i % 4 !== 3) && (i + 1 < tabKeys.length);
      if (hasRightSiblingLarge) wrapperClass += ' pr2-l';

      if (selectedTab === tab) tabClass += ' bg-mid-gray';

      pills.push(
        m('div', {class: wrapperClass}, 
          m(buttonElement, {
            class: tabClass,
            func: ctrl.selectTab.bind(this, tab),
            label: label
          })
        )
      );
    }

    return pills;
  };

  var activeTab = ctrl.tabs[selectedTab] || ctrl.tabs[Object.keys(ctrl.tabs)[0]];

  if (ctrl.options.horizontal) {
    return m('div', [
      m('div.cf', [
        m('div.flex.flex-wrap.items-start.w-100.tc.mb3', [
          tabs()
        ]),
        m('div.grid-item.overflow-hidden.mv3.f4', 
          m(activeTab[0], activeTab[1], activeTab[2])
        )
      ])
    ]);
  } else {
    return m('div', [
      m('div.cf', [
        m('div.fl.w-100.w-20-m.w-20-l.tc.mb3', [
          tabs()
        ]),
        m('div.fl.w-100.w-80-m.w-80-l.pl3-l.pl3-m.pl0.grid-item.overflow-hidden.mv3.f4', 
          m(activeTab[0], activeTab[1], activeTab[2])
        )
      ])
    ]);
  }
};

module.exports = component;
